/**
 * Promotion Card Component
 * Displays individual promotion with WhatsApp registration
 */

import { generateWhatsAppLink } from '../lib/whatsapp-utils.js';

/**
 * Create a promotion card element
 * @param {Object} promotion - Promotion data
 * @returns {HTMLElement} Card element
 */
export function createPromotionCard(promotion) {
    const card = document.createElement('div');
    card.className = 'promo-slide';
    
    const startDate = new Date(promotion.startDate);
    const endDate = new Date(promotion.endDate);
    
    const formatDate = (date) => date.toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric'
    });
    
    const whatsappUrl = generateWhatsAppLink(promotion);
    
    card.innerHTML = `
        <div class="promo-card">
            <div class="promo-card-image">
                <img src="${promotion.imageUrl || 'images/banner.jpg'}" alt="${promotion.title}">
                ${promotion.endingSoon ? '<span class="promo-badge ending-soon">🔥 Ending Soon!</span>' : ''}
                ${promotion.category ? `<span class="promo-category">${promotion.category}</span>` : ''}
            </div>
            <div class="promo-card-content">
                <h3 class="promo-card-title">${promotion.title}</h3>
                <p class="promo-card-desc">${promotion.description}</p>
                
                <div class="promo-card-details">
                    <p class="promo-card-date">
                        <i class="fas fa-calendar-alt"></i> 
                        ${formatDate(startDate)} - ${formatDate(endDate)}
                    </p>
                    ${promotion.venue ? `
                        <p class="promo-card-venue">
                            <i class="fas fa-map-marker-alt"></i> 
                            ${promotion.venue}
                        </p>
                    ` : ''}
                </div>
                
                <a href="${whatsappUrl}" target="_blank" rel="noopener" class="promo-register-btn">
                    <span class="btn-fill"></span>
                    <span class="btn-text"><i class="fab fa-whatsapp"></i> Register Now</span>
                </a>
            </div>
        </div>
    `;
    
    return card;
}

export default { createPromotionCard };
